import React from "react";

import {trackIntroDialogButtonClick} from "../tracking/eventTracker";
import {NumberOfPeople} from "../v2/commonTypes";
import {Col, Modal, Row, Stack} from "react-bootstrap";
import IntroDialogFirstIcon from "./dialogs/intro/IntroDialogFirstIcon";
import IntroDialogThirdIcon from "./dialogs/intro/IntroDialogThirdIcon";
import IntroDialogSecondIcon from "./dialogs/intro/IntroDialogSecondIcon";
import {isMobile} from "../helper";
import {Trans, useTranslation} from "react-i18next";

const IntroDialog = ({
                       isOpen,
                       closeModal,
                       numberOfPerson,
                       setNumberOfPerson,
                     }: {
  isOpen: boolean,
  closeModal: () => void;
  numberOfPerson: NumberOfPeople;
  setNumberOfPerson: (people: NumberOfPeople) => void;
}) => {
  const {t} = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const utmCampaign = urlParams?.get("utm_campaign");
  const referralCode = `FRIEND-${urlParams?.get("aic")}`;

  const isInvitedByFriend = utmCampaign && utmCampaign.indexOf("referralcandy") > -1;

  const onDialogConfirm = () => {
    closeModal();
    trackIntroDialogButtonClick(numberOfPerson);
  };

  return (
    <Modal show={isOpen} contentClassName="rounded-5 d-flex align-items-center">
      <div className="intro-dialog">
        <div className={`mb-3 ${isMobile() ? "" : "mx-5"}`}>
          <IntroDialogContent isInvitedByFriend={isInvitedByFriend} referralCode={referralCode} />
        </div>
        <div className="dialog-image-holder rounded-2 d-flex justify-content-center">
          <div className="my-2 px-2">
            {t("order.first_order_flow.intro_dialog.people_prefix")}
            <div className="small-switch-holder">
              <div className={`switch-selector l ${numberOfPerson === 2 && "active"}`}
                   onClick={() => setNumberOfPerson(2)}>
                2
              </div>
              <div className={`switch-selector r ${numberOfPerson === 4 && "active"}`}
                   onClick={() => setNumberOfPerson(4)}>
                4
              </div>
            </div>
            {t("order.first_order_flow.intro_dialog.people_suffix")}
          </div>
        </div>
        <button className="btn my-3 px-5 text-uppercase" onClick={onDialogConfirm}>
          {t("order.first_order_flow.intro_dialog.button")}
        </button>
      </div>
    </Modal>
  );
};

const IntroDialogContent = ({isInvitedByFriend, referralCode}: {isInvitedByFriend: boolean, referralCode: string}) => {
  const {t} = useTranslation();

  const discountAmount = 30;
  const validForDays = 7;

  if (isInvitedByFriend) {
    return (
      <div className="pb-0 m-3 mt-4 text-center mb-0">
        <h2>{t("order.first_order_flow.intro_dialog.invited.title", {discountAmount: discountAmount})}</h2>
        <div className="mx-auto" style={{maxWidth: 300}}>
          <div>
            <Trans i18nKey="order.first_order_flow.intro_dialog.invited.text1" values={{
              referralCode: referralCode,
              discountAmount: discountAmount,
            }} components={{strong: <strong />}} />
          </div>
          <div className="my-2">{t("order.first_order_flow.intro_dialog.invited.text2", {days: validForDays})}</div>
          <div className="my-2">{t("order.first_order_flow.intro_dialog.invited.text3")}</div>
        </div>
        <h2 className="my-0">{referralCode}</h2>
      </div>
    );
  }

  return (
    <>
      <h2 className="mt-4 text-center">
        {t("order.first_order_flow.intro_dialog.regular.title")}
      </h2>
      <Stack gap={2}>
        <DialogItem icon={<IntroDialogFirstIcon size={isMobile() ? 40 : 80} />}>
          {t("order.first_order_flow.intro_dialog.regular.first_item")}
        </DialogItem>
        <DialogItem icon={<IntroDialogSecondIcon size={isMobile() ? 40 : 80} />}>
          {t("order.first_order_flow.intro_dialog.regular.second_item")}
        </DialogItem>
        <DialogItem icon={<IntroDialogThirdIcon size={isMobile() ? 40 : 80} />}>
          {t("order.first_order_flow.intro_dialog.regular.third_item")}
        </DialogItem>
      </Stack>
    </>
  );
};

const DialogItem = ({icon, children}: {icon: React.ReactNode, children: React.ReactNode}): React.ReactElement =>
  <Row>
    <Col xs="auto" className="d-flex align-items-center">{icon}</Col>
    <Col className={`opacity-75 d-flex align-items-center text-left ${isMobile() ? "fs-6" : "fs-5"}`}>{children}</Col>
  </Row>;

export default IntroDialog;
